import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@apollo/client";

import { RootState } from "../AskVyrillReducer";
import { updateAskVyrillState } from "../Actions";
import { ASK_VYRILL_QUERY } from "../../../Queries/ask-vyrill";
import { getDateString, splitDateRange } from "../../../utilities";
import { allPrompts } from "../../../constants";
import moment from "moment";

const SuggestedPrompts = ({ isHistoryOpen }: { isHistoryOpen: boolean }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number | null>(null);
  const [scrollLeft, setScrollLeft] = useState<number | null>(null);

  const conversationId = useSelector(
    (state: RootState) => state.askVyrill.conversationId
  );
  const messages = useSelector((state: RootState) => state.askVyrill.messages);
  console.log(messages)
  const selectedPrompt = useSelector(
    (state: RootState) => state.askVyrill.selectedPrompt
  );
  const askVyrillDuration = useSelector(
    (state: RootState) => state.askVyrill.askVyrillDuration
  );
  const custom_start_date = useSelector(
    (state: any) => state.askVyrill.custom_start_date
  );
  const custom_end_date = useSelector(
    (state: any) => state.askVyrill.custom_end_date
  );
  const custom_start_date_string = custom_start_date
    ? moment(custom_start_date).toISOString()
    : "";
  const custom_end_date_string = custom_end_date
    ? moment(custom_end_date).toISOString()
    : "";

  const messagesLoading = useSelector(
    (state: RootState) => state.askVyrill.messagesLoading
  );

  const currentBrandId = useSelector(
    (state: any) => state.navbarStatsReducer.currentBrand._id
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const container = containerRef.current;

    const handleMouseDown = (e: MouseEvent) => {
      setIsDragging(true);
      setStartX(e.pageX - (container?.offsetLeft || 0));
      setScrollLeft(container?.scrollLeft || 0);
    };

    const handleMouseLeave = () => {
      setIsDragging(false);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - (container?.offsetLeft || 0);
      const walk = (x - (startX || 0)) * 1; // Adjust speed
      container!.scrollLeft = (scrollLeft || 0) - walk;
    };
    container?.addEventListener("mousedown", handleMouseDown);
    container?.addEventListener("mouseleave", handleMouseLeave);
    container?.addEventListener("mouseup", handleMouseUp);
    container?.addEventListener("mousemove", handleMouseMove);

    return () => {
      container?.removeEventListener("mousedown", handleMouseDown);
      container?.removeEventListener("mouseleave", handleMouseLeave);
      container?.removeEventListener("mouseup", handleMouseUp);
      container?.removeEventListener("mousemove", handleMouseMove);
    };
  }, [containerRef, isDragging, startX, scrollLeft]);

  const { refetch: refetchAskVyrill } = useQuery(ASK_VYRILL_QUERY, {
    skip: true || !currentBrandId,
    onError: (error) => {
      // Handle the error here
      dispatch(
        updateAskVyrillState({
          askVyrillTimoutError: true,
          messagesLoading: false,
        })
      );
    },
  });

  return (
    <div
      className={`suggested-prompts-section ${
        isHistoryOpen ? "expanded-prompt" : "non-expanded-prompt"
      }`}
      id="style-4"
      ref={containerRef}
    >
      {" "}
      {allPrompts.map((k, index) => {
        return (
          <div
            key={index}
            className={`suggested-item `}
            style={{ background: k.prompt === selectedPrompt ? "#F3FFFF" : "" }}
            onClick={
              messagesLoading
                ? () => {}
                : () => {
                    const newQuestion = {
                      content: k.prompt,
                      conversation_id: conversationId,
                      role: "user",
                      duration: askVyrillDuration?.value,
                      start_date: splitDateRange(
                        getDateString(askVyrillDuration?.value)
                      )?.startDate,
                      end_date: splitDateRange(
                        getDateString(askVyrillDuration?.value)
                      )?.endDate,
                      _id: "",
                    };

                    dispatch(
                      updateAskVyrillState({
                        messages: [...messages, newQuestion],
                        selectedPrompt: k.prompt,
                        messagesLoading: true,
                        askVyrillError: false,
                        askVyrillTimoutError: false,
                      })
                    );

                    refetchAskVyrill({
                      brandId: currentBrandId,
                      conversationId,
                      duration: askVyrillDuration?.value,
                      ...(askVyrillDuration.value === "custom" &&
                      custom_start_date_string &&
                      custom_end_date_string
                        ? {
                            start_date: custom_start_date_string,
                            end_date: custom_end_date_string,
                          }
                        : {}),
                      content: k.prompt,
                      role: "user",
                    }).then((result) => {
                      if (!result?.data?.askVyrill) {
                        dispatch(
                          updateAskVyrillState({
                            askVyrillError: true,
                            messagesLoading: false,
                          })
                        );
                      } else {
                        newQuestion._id =
                          result?.data?.askVyrill?.question_id || ""; // adding question id in new question
                        dispatch(
                          updateAskVyrillState({
                            messages: [
                              ...messages,
                              newQuestion,
                              result?.data?.askVyrill,
                            ],
                            messagesLoading: false,
                          })
                        );
                      }
                    });
                  }
            }
          >
            {k.label}
          </div>
        );
      })}
    </div>
  );
};

export default SuggestedPrompts;
